import { BuyPartsSection } from '@components/Product/Desktop/Panels/PartsCatalogue/BuyPartSection/BuyPartSection';
import { SearchStyles, ThinDivider } from '@components/Product/Desktop/Panels/PartsCatalogue/styles';
import { TabPanelElement } from '@components/Product/Shared/TabPanelElement';
import { device } from '@constants/mediaQueries';
import { spacing } from '@constants/spacing';
import { alpha, styled, useMediaQuery } from '@mui/material';
import type { PartNode } from '@partful/shared-types';
import { useKit } from '@services/kits/kit';
import { convertKitToPart } from '@services/kits/utils';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '../../Desktop/Panels/PartsCatalogue/Autocomplete';
import { SidebarNavigation } from '../../Desktop/Panels/PartsCatalogue/SidebarNavigation';
import { KitComponents } from './KitComponents';
import { KitNotes } from './KitNotes';

export function KitDetails() {
  const { currentKit, kitParent } = useKit();
  const isMobile = useMediaQuery(device.mobileOrTablet);
  const { t } = useTranslation('partsCatalogue');

  const { externalId, name } = currentKit!;
  const kitPart: PartNode = convertKitToPart(currentKit!);
  const notesExist = currentKit?.description !== null;

  return (
    <TabPanelElement>
      <KitDetailsContainer>
        {!isMobile && (
          <>
            <SearchStyles>
              <Autocomplete />
            </SearchStyles>
            <SidebarNavigation partParents={kitParent} />
          </>
        )}
        <StyledProductTitle>{isMobile ? t('kitSection.partNumber') : name}</StyledProductTitle>
        <StyledProductSubTitle>{externalId}</StyledProductSubTitle>
        <BuyPartsSection currentPart={kitPart} defaultBuyableQuantity="1" />
        <ThinDivider />
        {currentKit && notesExist && <KitNotes currentKit={currentKit} />}
        {currentKit && <KitComponents currentKit={currentKit} />}
      </KitDetailsContainer>
    </TabPanelElement>
  );
}

export const KitDetailsContainer = styled('div')`
  // Common to any breakpoint
  border-top: 1px solid ${({ theme }) => alpha(theme.palette.sidebarBackground.contrastText, 0.12)};
  background-color: ${({ theme }) => theme.palette.sidebarBackground.main};

  // Properties that change on different breakpoints
  margin-bottom: 0;
  padding: 0.5rem 1rem 1rem 1rem;

  // Desktop
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 1.5em;
    // padding: 0.5rem 1rem 1rem 1rem;
    padding: 0;
  }
`;

const StyledProductTitle = styled('h3')`
  font-weight: bold;
  margin-bottom: 0;
  margin-top: ${spacing.mediumSpacing};
  word-break: break-word;
  font-size: 1.75rem;
  position: relative;
  @media only screen and ${device.mobileOrTablet} {
    font-size: 16px;
    opacity: 70%;
    font-weight: normal;
  }
`;

const StyledProductSubTitle = styled('h5')`
  font-weight: normal;
  padding: ${spacing.smallSpacing} 0;
  margin-bottom: 0;
  word-break: break-word;
  font-size: normal;
`;
